// Components
import Button from '../../../../Button'
import Modal from 'components/Modal'

// Utilities
import swal from 'sweetalert'

const ReportModal = props => {
  // Props
  const {
    open,
    closeModal,
    setCheckbox,
    hint,
    answer,
    handleTextareaChange,
    handleOptionalReport,
  } = props

  return (
    <Modal title={'Raportează grila'} isOpen={open} closeModal={closeModal}>
      <p className="text-xs opacity-90 max-w-[500px] pr-[50px] mt-[5px] mb-[15px] text-over-primary-background">
        Dacă această grilă conține o eroare sau poate fi îmbunătățită,
        trimite-ne un raport. Ajută-ne să menținem calitatea și acuratețea
        materialelor oferite!
      </p>

      <p className="text-base text-over-primary-background">
        Ce dorești să raportezi la această grilă?
      </p>

      <div className="flex flex-col gap-1 text-over-primary-background">
        <div className="flex items-center gap-1 mt-2 text-lg">
          <input
            type="checkbox"
            id="reason-1"
            name="reason-1"
            onChange={() => {
              setCheckbox(cb => [!cb[0], cb[1], cb[2], cb[3]])
            }}
          />
          <label htmlFor="reason-1" className="text-xs tracking-[0.5px]">
            Cerința
          </label>
        </div>

        <div className="flex items-center gap-1 text-lg">
          <input
            type="checkbox"
            id="reason-2"
            name="reason-2"
            onChange={() => {
              setCheckbox(cb => [cb[0], !cb[1], cb[2], cb[3]])
            }}
          />
          <label htmlFor="reason-2" className="text-xs tracking-[0.5px]">
            Variantele de răspuns
          </label>
        </div>

        {hint !== undefined && (
          <div className="flex items-center gap-1 text-lg">
            <input
              type="checkbox"
              id="reason-3"
              name="reason-3"
              onChange={() => {
                setCheckbox(cb => [cb[0], cb[1], !cb[2], cb[3]])
              }}
            />
            <label htmlFor="reason-3" className="text-xs tracking-[0.5px]">
              Indiciul
            </label>
          </div>
        )}

        {answer && (
          <div className="flex items-center gap-1 text-lg">
            <input
              type="checkbox"
              id="reason-4"
              name="reason-4"
              onChange={() => {
                setCheckbox(cb => [cb[0], cb[1], cb[2], !cb[3]])
              }}
            />
            <label htmlFor="reason-4" className="text-xs tracking-[0.5px]">
              Explicația
            </label>
          </div>
        )}
      </div>

      <label
        htmlFor="modal-description"
        className="text-xs text-over-primary-background tracking-[0.5px]"
      >
        Descrie pe scurt problema observată:
      </label>
      <textarea
        className="border-over-primary-background border text-sm text-over-primary-background bg-container-background p-2 rounded w-[100%] min-w-[100%] max-w-[100%] h-[200px] max-h-[275px] min-h-[150px]"
        name="modal-description"
        id="modal-description"
        onChange={handleTextareaChange}
      />

      <Button
        className="bg-primary w-20 h-10"
        onClick={() => {
          handleOptionalReport()
          closeModal()
          swal({
            title: 'Feedback trimis',
            text: 'Mulțumim!',
            icon: 'success',
            timer: '2000',
            buttons: false,
          })
        }}
      >
        Trimite
      </Button>
    </Modal>
  )
}

export default ReportModal
